import React from 'react'; 
import { 
  TableContainer, 
  Table, 
  TableHead, 
  TableBody,
  TableRow, 
  TableCell, 
  TablePagination,
  TableFooter,
  makeStyles, useTheme, IconButton } from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight, LastPage, FirstPage } from '@material-ui/icons';
import './DataTable.css';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPage = (event) => {
    onPageChange(event, 0);
  };

  const handleBack = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNext = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPage = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPage}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPage /> : <FirstPage />}
      </IconButton>
      <IconButton onClick={handleBack} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNext}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPage}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPage /> : <LastPage />}
      </IconButton>
    </div>
  );
}

const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
});

const DataTable = ({tableHead, data, selectedItem }) => {
  const classes = useStyles2();
  let selectedSwitcher = selectedItem.toString().replace(/ /g, '');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(3);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data[selectedSwitcher].length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  /* console.log(selectedSwitcher)
  console.log(data)
  console.log(data[selectedSwitcher]) */
  return(
    <TableContainer style={{width: '80%', height: '100vh', paddingBottom: '15%'}} className="dataTableCont">
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {tableHead.map(value => (
              <TableCell key={value} align="left" className={'th'+value}>{value.toUpperCase()}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
        {(rowsPerPage > 0
            ? data[selectedSwitcher].slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data.selectedSwitcher
          ).map((row) => (
            <TableRow key={row.Name} style={{height: 100}} className="bugRow">
              <TableCell component="th" scope="row" style={{ width: 120}}>
                <b>{row.Code}</b>
              </TableCell>
              <TableCell component="th" scope="row" style={{ minWidth: 150 }}>
                {row.Name}
              </TableCell>
              <TableCell component="th" scope="row" style={{ minWidth: 200}}>
                {row.Description}
              </TableCell>
              {selectedSwitcher !== 'ImplementingFeatures' &&
                <TableCell component="th" scope="row">
                  {row.Workaround}
                </TableCell>
              }
              {selectedSwitcher !== 'FixedBugs' && selectedSwitcher !== 'ImplementingFeatures' &&
                <TableCell component="th" scope="row" style={{ width: 100}}>
                  {row.FixedIn}
                </TableCell>
              }
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 33 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[3, 5, 10]}
              colSpan={6}
              count={data[selectedSwitcher].length}
              rowsPerPage={rowsPerPage < 3 ? data[selectedSwitcher].length : rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>   
      </Table>
    </TableContainer>
  )
}

export default DataTable;
